export const parentNavigate = (path) => {
  const payload = {
    action: "navigateToHome",
    url: path,
    type: "NAVIGATE_IFRAME_INTERNAL",
    path: path,
  };
  if (window.parent) {
    window.parent.postMessage(payload, "*");
  }
  if (window.parent !== window) {
    window.postMessage(payload, "*");
  }
};
